module.exports = __webpack_public_path__ + "static/img/9.a635df2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/sp/9.png
// module id = QRDr
// module chunks = 0